/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
import { Redirect, Route } from 'react-router-dom';

import { isAuthenticatedVar } from 'Apollo/config';
import UnAuthorized from 'views/Shared/components/UnAuthorized';
import { isAuthenticated, getUserRole } from '../views/Auth/AuthHelper';

const RoleRoute = ({ component: Component, ...restOfProps }) => {
    const userRole = getUserRole();
    const loggedIn = isAuthenticated();
    isAuthenticatedVar(loggedIn);
    return (
        <Route
            {...restOfProps}
            render={props => (loggedIn
                ? userRole === 'ADMIN' ? <Component {...props} /> : <UnAuthorized /> : <Redirect to="/login" />)}
        />
    );
};

export default RoleRoute;
